const languages = [
    {name: 'English', code: 'en-GB', emoji: '🇬🇧'},
    {name: 'Czech',	code: 'cs', emoji: '🇨🇿'},
    {name: 'Danish', code: 'da', emoji: '🇩🇰'},
    {name: 'Dutch', code: 'nl', emoji: '🇳🇱'},
    {name: 'Estonian', code: 'et', emoji: '🇪🇪'},
    {name: 'French', code: 'fr', emoji: '🇫🇷'},
    {name: 'German', code: 'de', emoji: '🇩🇪'},
    {name: 'Greek', code: 'el', emoji: '🇬🇷'},
    {name: 'Hungarian', code: 'hu', emoji: '🇭🇺'},
    {name: 'Latvian', code: 'lv', emoji: '🇱🇻'},
    {name: 'Lithuanian', code: 'lt', emoji: '🇱🇹'},
    {name: 'Norwegian', code: 'no', emoji: '🇳🇴'},
    {name: 'Portuguese', code: 'pt-PT', emoji: '🇵🇹'},
    {name: 'Slovak', code: 'sk', emoji: '🇸🇰'},
    {name: 'Slovenian', code: 'sl', emoji: '🇸🇮'},
    {name: 'Spanish', code: 'es', emoji: '🇪🇸'},
    {name: 'Swedish', code: 'sv', emoji: '🇸🇪'},
];

export default languages;